module.exports = __webpack_public_path__ + "458fe9cc1fe18f61c81ecd6d241c6f4b.jpg";